import { FormEvent, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createPress, listPress, resetPressPassword } from '../api/portal';
import { ApiError } from '../api/client';
import { copyText } from '../lib/clipboard';

export function PressPage() {
  const qc = useQueryClient();
  const seats = useQuery({ queryKey: ['portal-press'], queryFn: listPress });
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [reveal, setReveal] = useState<{ email: string; password: string } | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const create = useMutation({
    mutationFn: () => createPress({ company_name: name.trim(), contact_email: email.trim() }),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ['portal-press'] });
      setReveal({ email: res.contact_email, password: res.portal_password });
      setName('');
      setEmail('');
      setErr(null);
    },
    onError: (e) => setErr(e instanceof ApiError ? e.message : String(e)),
  });
  const reset = useMutation({
    mutationFn: (id: string) => resetPressPassword(id),
    onSuccess: (res, id) => {
      const seat = (seats.data ?? []).find((s) => s.id === id);
      setReveal({ email: seat?.contact_email ?? '', password: res.portal_password });
    },
    onError: (e) => setErr(e instanceof ApiError ? e.message : String(e)),
  });

  return (
    <div>
      <div className="page-head">
        <div className="page-kicker">Liga</div>
        <h1 className="page-title">Press desk</h1>
        <p className="page-sub">
          Novinar vidi samo FT: zapisnik, zvanično, copy story — ne živi PBP.
          Liga kontroliše ko sme.
        </p>
      </div>
      <form
        className="card mb-4 grid gap-3 p-4 md:grid-cols-3"
        onSubmit={(e: FormEvent) => { e.preventDefault(); create.mutate(); }}
      >
        <div>
          <label className="label">Redakcija</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} required placeholder="Sport klub" />
        </div>
        <div>
          <label className="label">Email</label>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="flex items-end">
          <button className="btn-primary" disabled={create.isPending}>Dodaj sedište</button>
        </div>
      </form>
      {err && <div className="alert-bad mb-3">{err}</div>}
      {reveal && (
        <div className="card mb-4 p-3 text-sm text-amber-100">
          Lozinka za {reveal.email}: <code className="break-all">{reveal.password}</code>
          <button type="button" className="btn-ghost ml-2 text-xs" onClick={() => copyText(`${reveal.email}\n${reveal.password}`)}>Kopiraj</button>
        </div>
      )}
      <div className="card p-4">
        <table className="table">
          <thead>
            <tr><th>Redakcija</th><th>Email</th><th></th></tr>
          </thead>
          <tbody>
            {(seats.data ?? []).map((s) => (
              <tr key={s.id}>
                <td className="text-white">{s.company_name}</td>
                <td className="text-slate-400">{s.contact_email}</td>
                <td>
                  <button type="button" className="btn-ghost text-xs" onClick={() => reset.mutate(s.id)}>
                    Reset lozinke
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {(seats.data ?? []).length === 0 && (
          <div className="py-6 text-center text-sm text-slate-500">Još nema press sedišta.</div>
        )}
      </div>
    </div>
  );
}
